import React from 'react'
import { FaDollarSign, FaWallet } from 'react-icons/fa'
import toast from 'react-hot-toast'
import { Circle } from '@mui/icons-material'
import { UserDepositBonusModelUtils } from 'mvppoker-portal-common/model/UserDepositBonusModelUtils'
import ContextMenu from '../../ContextMenu/ContextMenu'
import { MVPDropdownLink } from '../../Link/MVPDropdownLink'
import IconDeposit from '../../svg/IconDeposit'
import IconWithdraw from '../../svg/IconWithdraw'
import WalletDepositBonusModal from '../../modals/WalletDepositBonusModal/WalletDepositBonusModal'
import WalletDepositBonusInfoModal from '../../modals/WalletDepositBonusInfoModal/WalletDepositBonusInfoModal'
import WalletAddressModal from '../../modals/WalletAddressModal/WalletAddressModal'
import WalletAddFundsModal from '../../modals/WalletAddFundsModal/WalletAddFundsModal'
import { useDepositBonus } from '../../../state/hooks/ProfileDataHooks'
import WalletWithdrawFundsModal from '../../modals/WalletWithdrawFundsModal/WalletWithdrawFundsModal'

export const WalletMenu = () =>
{
	const depositBonus = useDepositBonus()
	
	const onClickUpdateWallet = () =>
	{
		WalletAddressModal.Show()
	}
	const onClickWithdraw = () =>
	{
		WalletWithdrawFundsModal.Show()
	}
	const onClickDepositBonus = () =>
	{
        if (depositBonus === undefined){
			WalletDepositBonusInfoModal.Show()
            return
        }

        if (depositBonus.claimed){
			toast.success(`Well Done!\n\nYou've cashed your full $${depositBonus.totalBonusAmount} bonus!\n\nKeep on stacking those chips!`)
			return
        }
		WalletDepositBonusModal.Show()
	}
	const onClickDeposit = () =>
	{
		WalletAddFundsModal.Show()
	}

	const showDepositBonusIndicator = depositBonus && UserDepositBonusModelUtils.ShouldShowIndicator(depositBonus)

	return ( 
		<ContextMenu id='wallet-ctx-menu' alignment='center'>
			{/* <MVPDropdownLink onClick={onClickUpdateWallet}>
				<FaWallet style={{ display: 'inline' }} />
				&nbsp;&nbsp;WALLET ADDRESS
			</MVPDropdownLink> */}
			{/* <MVPDropdownLink onClick={onClickWithdraw}>
				<IconWithdraw />
				&nbsp;&nbsp;WITHDRAW
			</MVPDropdownLink> */}
			{/* <MVPDropdownLink onClick={onClickDepositBonus}>
				<FaDollarSign />
				&nbsp;&nbsp;DEPOSIT BONUS
				{showDepositBonusIndicator && <Circle color='error' style={{marginLeft:'5px', marginBottom:'10px', width:'12px', height:'12px'}}/>}
			</MVPDropdownLink> */}
			<MVPDropdownLink onClick={onClickDeposit}>
				<IconDeposit />
				&nbsp;&nbsp;DEPOSIT
			</MVPDropdownLink>
		</ContextMenu>
	)
}